export * from './components/PeoplePicker/index';